import styled from 'styled-components';

import { font } from '../../../atoms/typography';
import { color } from '../../../atoms/colors';
import { atMinWidth } from '../../../atoms/breakpoints';
import { spacing } from '../../../atoms/spacing';
import { containers } from '../../../atoms/containers';

import { sizes, variants } from '../../CallToAction/styles/CallToAction.styled';

const eyebrowMap = {
  Light: `color: ${color.blue[800]}`,
  Dark: `color: ${color.blue[200]}`,
  Neutral: `color: ${color.primary[700]}`,
  Red: `color: ${color.primary[700]}`,
  'Blue Linear': `color: ${color.primary[700]}`,
  'Midnight/25': `color: ${color.blue[800]}`,
};

const headingMap = {
  Light: `color: ${color.darkBlue[1000]}`,
  Dark: `color: ${color.common.white}`,
  Neutral: `color: ${color.darkBlue[900]}`,
  Red: `color: ${color.darkBlue[900]}`,
  'Blue Linear': `color: ${color.darkBlue[900]}`,
  'Midnight/25': `color: ${color.darkBlue[1000]}`,
};

const subheadMap = {
  Light: `color: ${color.darkBlue[600]}`,
  Dark: `color: ${color.darkBlue[100]}`,
  Neutral: `color: ${color.darkBlue[600]}`,
  Red: `color: ${color.darkBlue[600]}`,
  'Blue Linear': `color: ${color.darkBlue[600]}`,
  'Midnight/25': `color: ${color.darkBlue[600]}`,
};

const primaryButtonMap = {
  Light: variants['Filled - Blue'],
  Dark: variants['Filled - Blue'],
  Neutral: variants['Filled - Blue'],
  Red: variants['Filled - Red'],
  'Blue Linear': variants['Filled - Blue'],
  'Midnight/25': variants['Filled - Blue'],
};

const secondaryButtonMap = {
  Light: variants['Outline - Dark'],
  Dark: variants['Outline - White'],
  Neutral: variants['Outline - Blue'],
  Red: variants['Outline - Red'],
  'Blue Linear': variants['Outline - Blue'],
  'Midnight/25': variants['Outline - Blue'],
};

export const Container = styled.div`
  width: 100%;
  z-index: 3;
  max-width: ${containers.md};
  display: flex;
  flex-direction: column;
  align-items: ${({ alignment }) =>
    alignment === 'center' ? 'center' : 'flex-start'};
  gap: ${spacing[48]};
  padding: ${spacing[0]} ${spacing[24]};
  margin: ${spacing[0]} auto;
  ${atMinWidth.sm`
    padding: ${spacing[0]} ${spacing[32]};
  `}
  ${atMinWidth.xl`
    max-width: ${containers.xl};
  `}
`;

export const Text = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: ${({ alignment }) =>
    alignment === 'left' ? 'flex-start' : 'center'};
  text-align: ${({ alignment }) => (alignment === 'left' ? 'left' : 'center')};
  gap: ${spacing[16]};
  margin: ${({ alignment }) =>
    alignment === 'left' ? '0px 0px 0px 0px' : '0px auto'};
  .eyebrow {
    ${font('overline', 'md', '500')}
    ${({ theme }) => eyebrowMap[theme]};
    color: ${({ kickerColor }) => kickerColor};
  }
  .heading {
    ${font('display', 'sm', '500')}
    ${({ theme }) => headingMap[theme]};
    letter-spacing: -0.96px;

    ${atMinWidth.sm`
      ${font('display', 'md', '500')}
      letter-spacing: -0.96px;
    `}
    ${atMinWidth.xl`
      ${font('display', 'lg', '500')}
      letter-spacing: -0.96px;
    `}
  }
  .subhead {
    &,
    & p {
      ${font('text', 'lg', '400')}
      ${({ theme }) => subheadMap[theme]};
    }
  }
`;

export const Buttons = styled.div`
  width: 100%;
  display: flex;
  align-items: ${({ alignment }) =>
    alignment === 'left' ? 'flex-start' : 'center'};
  flex-direction: column;
  gap: ${spacing[16]};
  margin-top: ${spacing[16]};
  ${atMinWidth.md`
    width: fit-content;
    flex-direction: row;
    margin: ${({ alignment }) =>
      alignment === 'left' ? '0px 0px 0px 0px' : '0px auto'};
  `}
  a {
    width: 100%;
    ${sizes.xl}
    ${atMinWidth.md`
      width: fit-content;
    `}
  }
  .primary-button {
    ${({ theme }) => primaryButtonMap[theme]};
  }
  .secondary-button {
    ${({ theme }) => secondaryButtonMap[theme]};
  }
`;

export const Image = styled.div`
  width: 100%;
  max-width: ${props => (props.fullwidthImage ? 'unset' : '100%')};
  margin: 0px auto;

  .gatsby-image-wrapper,
  img {
    width: 100%;
  }
`;

export const Video = styled.div`
  width: 100%;
  max-width: ${props => (props.fullwidthImage ? 'unset' : '1008px')};
  margin: 0 auto;
`;
